import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import type { AdminActionType } from '../../../api/types';
import { PageHeader } from '../../../shared/ui/PageHeader';
import { Spinner } from '../../../shared/ui/Spinner';
import { useAuditLog } from '../hooks/useAuditLog';
import { AuditLogFilters } from '../components/AuditLogFilters';
import { AuditLogTable } from '../components/AuditLogTable';
import styles from './LogsPage.module.css';

// PARA-106, AC-9.
export function LogsPage(): JSX.Element {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const adminIdParam = searchParams.get('admin_id');
  const { data, isLoading } = useAuditLog({
    date_from: searchParams.get('date_from') ?? undefined,
    date_to: searchParams.get('date_to') ?? undefined,
    admin_id: adminIdParam ? Number(adminIdParam) : undefined,
    action_type: (searchParams.get('action_type') as AdminActionType | null) ?? undefined,
  });

  return (
    <section>
      <PageHeader title={t('logs.title')} />
      <div className={styles.stack}>
        <AuditLogFilters />
        {isLoading || !data ? <Spinner /> : <AuditLogTable entries={data} />}
      </div>
    </section>
  );
}
